<template>
  <div class="column">

    <div class="card dash-card headercard" style="min-height: 580px;">
      <div class="card-header dash-card-header">
        <div style="height: 40px;"></div>
      </div>

      <!-- Cluster 6 -->
      <div class="card-body dash-card-body">
        <tableitem :overallByWave="getOverallByWave"
                   :kpi="getKpiCustomerTreatment"
                   :hideNSC="true"
                   :isExtraNarrow="true"
                   :isHeader="true"
                   :isBMWMoto="true" />
        <titleunderline />

        <div class="dash-card-inner">
          <tableitem :overallByWave="getOverallByWave" :isBMWMoto="true" :kpi="getKpi2_2" />
          <tableitem :overallByWave="getOverallByWave" :isBMWMoto="true" :kpi="getKpi5_2" />
          <tableitem :overallByWave="getOverallByWave" :isBMWMoto="true" :kpi="getKpi8_2" />
          <tableitem :overallByWave="getOverallByWave" :isBMWMoto="true" :kpi="getKpi9_2" />
          <tableitem :overallByWave="getOverallByWave" :isBMWMoto="true" :kpi="getKpi11_4" />
          <tableitem :overallByWave="getOverallByWave" :isBMWMoto="true" :kpi="getKpi13_2" />
          <tableitem :overallByWave="getOverallByWave" :isBMWMoto="true" :kpi="getKpi16" />
          <tableitem :overallByWave="getOverallByWave" :isBMWMoto="true" :kpi="getKpi17" />
        </div>
      </div>
    </div>

    <!-- Shops Count Stats -->
    <div class="card dash-card" id="shops">
      <div class="card-header dash-card-header" style="height: 30px; background: transparent; ">
        <h3 class="spacing">{{$t('Webportal.DashboardBMW.NumberOfShops')}} <span class="smalltext">({{$t('Webportal.DashboardBMW.Total')}} {{ getShops }})</span></h3>
      </div>
      <div class="card-body dash-card-body">
        <ShopsOverall style="width: 100%; height:127px;"
                      :overallValues="getOverallByWave"
                      :isCompetitionOverall="false"
                      :isBMWMoto="true"
                      />
      </div>
    </div>

    <!-- Legende -->
    <LegendControl :workingStandardsText="$t('Webportal.DashboardBMWMoto.RetailStandards')"
                   :successFactorsText="$t('Webportal.DashboardBMWMoto.FiveMust')"
                   :isBMWMoto="true" />

  </div>

</template>


<script>

  import performanceitem from './PerformanceItem'
  import tableitem from './TableItem.vue'
  import WideNscItem from './WideNscItem.vue'
  import ShopsOverall from './ShopsOverall'
  import LegendControl from './LegendControl'
  import titleunderline from './TitleUnderline'

  export default {
    name: 'BMWMotorradCustomerTreatmentColumn',

    components: {
      performanceitem,
      tableitem,
      WideNscItem,
      ShopsOverall,
      LegendControl,
      titleunderline
    },

    props:[
      'dashdata'
    ],

    methods:{
      getKpiByString: function (code) {
        if (this.dashdata && this.dashdata.KPI && _.size(this.dashdata.KPI) > 0)
          return _.find(this.dashdata.KPI, (x) => x.KpiCode === code)
      },
      getKpiGroupByString: function (code) {
        if (this.dashdata && this.dashdata.KPIGroup && _.size(this.dashdata.KPIGroup) > 0)
          return _.find(this.dashdata.KPIGroup, (x) => x.KpiCode === code)
      },
      getQuestionByString: function(code) {
        if (this.dashdata && this.dashdata.Question && _.size(this.dashdata.Question) > 0)
          return _.find(this.dashdata.Question, (x) => x.KpiCode === code)
      },
      getOverallItem: function() {
        if (this.dashdata && this.dashdata.Overall && _.size(this.dashdata.Overall) > 0)
          return this.dashdata.Overall[0]
        return undefined
      },
    },

    computed: {
      getKpiCustomerTreatmentName: function() {
        const item = this.getKpiGroupByString('Customer Treatment')
        if (item) { return item.KpiName }
        return '-'
      },

      getKpiCustomerTreatment: function() {
        return this.getKpiGroupByString('Customer Treatment')
      },

      getOverallByWave: function() {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0)
          return this.dashdata.OverallByWave[0]
        return undefined
      },

      getShops: function () {
        const item = this.getOverallItem()
        if (!item) { return '-' }
        return item.NumberOfShopsTotal
      },

      getKpi2_2: function() {
        return this.getQuestionByString('0026878')
      },

      getKpi5_2: function() {
        return this.getQuestionByString('0038933')
      },

      getKpi8_2: function() {
        return this.getQuestionByString('0038937')
      },

      getKpi9_2: function() {
        return this.getQuestionByString('0038939')
      },

      getKpi11_4: function() {
        return this.getQuestionByString('0026911')
      },

      getKpi13_2: function() {
        return this.getQuestionByString('0026912')
      },

      getKpi16: function() {
        return this.getQuestionByString('0026921')
      },

      getKpi17: function() {
        return this.getQuestionByString('0026922')
      }
    }
  }

</script>

<style scoped>

.card-body {
  padding: 0px;
}
  .ctRect{
    width: 16px;
    height: 16px;
    vertical-align: middle;
    margin-top: 5px;
  }

  .left {
      overflow: hidden;
      min-height: 26px;
  }

  .right {
      float: right;
      width: 23px;
      min-height: 26px;
  }

  .ctNoNsc {
    width: 95%;
    float: left;
    text-align: center;
    margin-top: 3px;
    margin-left: 6px;
    margin-right: 6px;
  }

  .hasnonsc{
    width: 100%;
  }

  .hasnsc{
     width: 65%;
  }

  .hasnonscitem{
    width: 0%;
  }

  .hasnscitem{
     width: 30%;
  }

  .p {
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    -o-hyphens: auto;
    hyphens: auto;
    word-wrap:break-word;
    text-overflow: ellipsis;
    text-overflow: unset;
  }

  .headercard{
    height: 520px;
  }

  .column{
    margin:0px;
    padding: 0px;
    position: relative;
    top: 0px;
    margin-block-end: 0px;
    margin-inline-end: 2px;
  }

  .nscHeader{
    min-height: 77px;
  }

  .noNscHeader{
    min-height: 60px;
  }

  h3{
    font-size: 10pt;
    margin: 0pt;
    text-align: center;
    font-stretch: extra-condensed;
    letter-spacing: -0.12em;
    white-space: normal;
    margin-top: 4px;
    font-weight: bold;
  }

.spacing{
  letter-spacing: unset;
}
</style>
